import React from "react";
import { Form, useFormikContext } from "formik";
import * as Yup from "yup";
import TextField from "../../../../Forms/TextField";
import NavigationalButtons from "../Components/NavigationalButtons";
import NoteComponent from "../../../../Util/NoteComponent";
import { Stack, Text, ChoiceGroup } from "@fluentui/react";

export const basicInfoValidation = Yup.object().shape({
    reportUserDetail: Yup.object().shape({
        firstName: Yup.string().required("First Name is required"),
        lastName: Yup.string().required("Last Name is required"),
        emailAddress: Yup.string().email("Invalid email format").required("Email is required"),
        position: Yup.string().nullable(),
        phoneNumber: Yup.string().nullable(),
        status: Yup.string().required("Status is required"),
    }),
});

const BasicInfoStep = ({ staffId }) => {
    const { values, isSubmitting, isValid, setFieldValue } = useFormikContext();

    const statusOptions = [
        { key: "A", text: "Active" },
        { key: "D", text: "Disabled" },
    ];

    return (
        <Form>
            <Stack tokens={{ childrenGap: 20 }} styles={{ root: { padding: "20px 0" } }}>
                <Stack tokens={{ childrenGap: 15 }} styles={{ root: { maxWidth: 600 } }}>
                    <TextField name="reportUserDetail.firstName" label="First Name" required />
                    <TextField name="reportUserDetail.lastName" label="Last Name" required />
                    <TextField name="reportUserDetail.emailAddress" label="Email" required />
                    <TextField name="reportUserDetail.position" label="Position" />
                    <Text variant="small" styles={{ root: { marginTop: -10, color: "#605E5C" } }}>
                        Specify the user's job title or role within the organization.
                    </Text>

                    <TextField name="reportUserDetail.phoneNumber" label="Phone" />

                    <ChoiceGroup
                        label="Status"
                        required
                        selectedKey={values.reportUserDetail?.status}
                        options={statusOptions}
                        onChange={(e, option) => {
                            setFieldValue("reportUserDetail.status", option.key);
                        }}
                    />
                    <Text variant="small" styles={{ root: { color: "#605E5C", marginBottom: 15 } }}>
                        Enables or disables this user's old reports site account. Note that this
                        does NOT affect access to the Client Console which is managed inside Auth0.
                    </Text>
                    {!staffId && (
                        <NoteComponent
                            message="Note that creating a new Report User does not send an email to the user inviting them to setup their account on the old reporting system. If this is required please get in touch with IT."
                            isMultiline={true}
                        />
                    )}
                    <NavigationalButtons
                        onNextProps={{
                            disabled: !isValid || isSubmitting,
                            type: "submit",
                            text: staffId ? "Save and Continue" : "Create and Continue",
                        }}
                        loading={isSubmitting}
                    />
                </Stack>
            </Stack>
        </Form>
    );
};

export default BasicInfoStep;
